import React from 'react'
import './AdminMenu.scss'
import AminMenuDataCard from './AminMenuDataCard/AminMenuDataCard'
import AdminMenuLinkCard from './AdminMenuLinkCard/AdminMenuLinkCard'
import { useLocation } from 'react-router-dom'

const AdminMenu = ({clientsData, myTarif}) => {
  const location = useLocation()
  return (
    <div className='AdminMenu_container' style={{display: location.pathname === '/notNetwork' && 'block', height: location.pathname === '/notNetwork' && '100%'}}>
       <AminMenuDataCard clientsData={clientsData} location={location.pathname} tarifName={myTarif}/>
       {
        location.pathname !== '/notNetwork' &&
       <AdminMenuLinkCard/>
       }
    </div>
  )
}

export default AdminMenu
